/**
 * This file is the entry point for the React app, it sets up the root
 * element and renders the App component to the DOM.
 *
 * It is included in `src/index.html`.
 */

import { createRoot } from "react-dom/client";
import { App } from "./App";
import { StoreProvider } from "./Store";

import "@radix-ui/themes/styles.css";
import { Theme } from '@radix-ui/themes';


function start() {
  const root = createRoot(document.getElementById("root")!);
  root.render(
    <StoreProvider>
      <Theme appearance="dark">
        <App />
      </Theme>
    </StoreProvider>
  );
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", start);
} else {
  start();
}
